import Vue from 'vue'
import VueRouter from 'vue-router'
import Authenticated from '@/views/Authenticated.vue'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/authenticated/dashboard.vue'
import Invitation from '@/views/authenticated/invitations/Invitation.vue'
import Invoice from '@/views/authenticated/invoices/Invoice.vue'
import InvoiceCreate from '@/views/authenticated/invoices/Create.vue'
import Algolia from '@/views/authenticated/algolia/Algolia.vue'
import Aerator from '@/views/authenticated/aerators/Aerator.vue'
import AeratorIndex from '@/views/authenticated/aerators/Index.vue'
import AeratorCreatePackage from '@/views/authenticated/aerators/CreatePackage.vue'
import AeratorCreateBootloader from '@/views/authenticated/aerators/CreateBootloader.vue'
import AeratorCreateFirmware from '@/views/authenticated/aerators/CreateFirmware.vue'
import AeratorCreateHardware from '@/views/authenticated/aerators/CreateHardware.vue'
import AeratorUpdatePackage from '@/views/authenticated/aerators/UpdatePackage.vue'
import AeratorUpdateBootloader from '@/views/authenticated/aerators/UpdateBootloader.vue'
import AeratorUpdateFirmware from '@/views/authenticated/aerators/UpdateFirmware.vue'
import AeratorUpdateHardware from '@/views/authenticated/aerators/UpdateHardware.vue'
import AeratorCreateProgrammed from '@/views/authenticated/aerators/CreateProgrammed.vue'
import Ambassador from '@/views/authenticated/ambassadors/Ambassador.vue'
import AmbassadorIndex from '@/views/authenticated/ambassadors/Index.vue'
import AmbassadorCreate from '@/views/authenticated/ambassadors/Create.vue'
import AmbassadorRead from '@/views/authenticated/ambassadors/Read.vue'
import AmbassadorUpdate from '@/views/authenticated/ambassadors/Update.vue'
import Announcement from '@/views/authenticated/announcements/Announcement.vue'
import AnnouncementIndex from '@/views/authenticated/announcements/Index.vue'
import AnnouncementCreate from '@/views/authenticated/announcements/Create.vue'
import AnnouncementUpdate from '@/views/authenticated/announcements/Update.vue'
import Wine from '@/views/authenticated/wines/Wine.vue'
import WineIndex from '@/views/authenticated/wines/Index.vue'
import WineCreate from '@/views/authenticated/wines/Create.vue'
import WineRead from '@/views/authenticated/wines/Read.vue'
import WineUpdate from '@/views/authenticated/wines/Update.vue'
import WineTemplate from '@/views/authenticated/wine-templates/WineTemplate.vue'
import WineTemplateIndex from '@/views/authenticated/wine-templates/Index.vue'
import WineTemplateRead from '@/views/authenticated/wine-templates/Read.vue'
import WineTemplateUpdate from '@/views/authenticated/wine-templates/Update.vue'
import WineForm from '@/views/authenticated/wine-forms/WineForm.vue'
import WineFormIndex from '@/views/authenticated/wine-forms/Index.vue'
import WineFormValidate from '@/views/authenticated/wine-forms/Validate.vue'
// import UncheckedWine from '@/views/authenticated/unchecked-wines/UncheckedWine.vue'
// import UncheckedWineIndex from '@/views/authenticated/unchecked-wines/Index.vue'
// import UncheckedWineCheck from '@/views/authenticated/unchecked-wines/Check.vue'
import WineCommentValidate from '@/views/authenticated/wine-comments/Validate.vue'
import Aroma from '@/views/authenticated/aromas/Aroma.vue'
import AromaIndex from '@/views/authenticated/aromas/Index.vue'
import AromaCreate from '@/views/authenticated/aromas/Create.vue'
import AromaUpdate from '@/views/authenticated/aromas/Update.vue'
import FoodPairing from '@/views/authenticated/food-pairings/FoodPairing.vue'
import FoodPairingIndex from '@/views/authenticated/food-pairings/Index.vue'
import FoodPairingCreate from '@/views/authenticated/food-pairings/Create.vue'
import FoodPairingUpdate from '@/views/authenticated/food-pairings/Update.vue'
import AiContentReport from '@/views/authenticated/ai-content-reports/AiContentReport.vue'
import AiContentReportIndex from '@/views/authenticated/ai-content-reports/Index.vue'
import Quiz from '@/views/authenticated/quizzes/Quiz.vue'
import QuizIndex from '@/views/authenticated/quizzes/Index.vue'
import QuizCreate from '@/views/authenticated/quizzes/Create.vue'
import QuizUpdate from '@/views/authenticated/quizzes/Update.vue'
import FeaturedGrapeIndex from '@/views/authenticated/featured-grapes/Index.vue'
import FeaturedRegionIndex from '@/views/authenticated/featured-regions/Index.vue'
import WineOfTheMonth from '@/views/authenticated/wines-of-the-month/WineOfTheMonth.vue'
import WineOfTheMonthIndex from '@/views/authenticated/wines-of-the-month/Index.vue'
import WineOfTheMonthCreate from '@/views/authenticated/wines-of-the-month/Create.vue'
import WineOfTheMonthUpdate from '@/views/authenticated/wines-of-the-month/Update.vue'
import Grape from '@/views/authenticated/grapes/Grape.vue'
import GrapeIndex from '@/views/authenticated/grapes/Index.vue'
import GrapeRead from '@/views/authenticated/grapes/Read.vue'
import GrapeCreate from '@/views/authenticated/grapes/Create.vue'
import GrapeUpdate from '@/views/authenticated/grapes/Update.vue'
import SuperAmbassador from '@/views/authenticated/super-ambassadors/SuperAmbassador.vue'
import SuperAmbassadorIndex from '@/views/authenticated/super-ambassadors/Index.vue'
import SuperAmbassadorRead from '@/views/authenticated/super-ambassadors/Read.vue'
import SuperAmbassadorCreate from '@/views/authenticated/super-ambassadors/Create.vue'
import SuperAmbassadorUpdate from '@/views/authenticated/super-ambassadors/Update.vue'
import Appellation from '@/views/authenticated/appellations/Appellation.vue'
import AppellationIndex from '@/views/authenticated/appellations/Index.vue'
import AppellationRead from '@/views/authenticated/appellations/Read.vue'
import AppellationCreate from '@/views/authenticated/appellations/Create.vue'
import AppellationUpdate from '@/views/authenticated/appellations/Update.vue'
import Region from '@/views/authenticated/regions/Region.vue'
import RegionIndex from '@/views/authenticated/regions/Index.vue'
import RegionRead from '@/views/authenticated/regions/Read.vue'
import RegionCreate from '@/views/authenticated/regions/Create.vue'
import RegionUpdate from '@/views/authenticated/regions/Update.vue'
import Domain from '@/views/authenticated/domains/Domain.vue'
import DomainIndex from '@/views/authenticated/domains/Index.vue'
import DomainRead from '@/views/authenticated/domains/Read.vue'
import DomainCreate from '@/views/authenticated/domains/Create.vue'
import DomainUpdate from '@/views/authenticated/domains/Update.vue'
import Company from '@/views/authenticated/companies/Company.vue'
import CompanyIndex from '@/views/authenticated/companies/Index.vue'
import CompanyRead from '@/views/authenticated/companies/Read.vue'
import CompanyCreate from '@/views/authenticated/companies/Create.vue'
import CompanyUpdate from '@/views/authenticated/companies/Update.vue'
import Changelog from '@/views/authenticated/changelogs/Changelog.vue'
import ChangelogIndex from '@/views/authenticated/changelogs/Index.vue'
import ChangelogCreate from '@/views/authenticated/changelogs/Create.vue'
import ChangelogUpdate from '@/views/authenticated/changelogs/Update.vue'
import SalesRead from '@/views/authenticated/sales/Read.vue'
import Order from '@/views/authenticated/orders/Order.vue'
import OrderStats from '@/views/authenticated/orders/Stats.vue'
import OrderIndex from '@/views/authenticated/orders/Index.vue'
import OrderRead from '@/views/authenticated/orders/Read.vue'
import User from '@/views/authenticated/users/User.vue'
import UserIndex from '@/views/authenticated/users/Index.vue'
import UserRead from '@/views/authenticated/users/Read.vue'
import Billing from '@/views/authenticated/billing/Billing.vue'
import BillingProducts from '@/views/authenticated/billing/Products.vue'
import BillingEvents from '@/views/authenticated/billing/Events.vue'
import BillingGrants from '@/views/authenticated/billing/Grants.vue'
import { authenticationGuard } from 'aveine-toolbox'

Vue.use(VueRouter)

const routes = [
  {
    path: '/authenticated',
    beforeEnter: authenticationGuard,
    component: Authenticated,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: 'invitations',
        name: 'invitations',
        component: Invitation
      },
      {
        path: 'invoices',
        name: 'Invoices',
        component: Invoice
      },
      {
        path: 'invoices/add/:id',
        name: 'InvoiceCreate',
        component: InvoiceCreate
      },
      {
        path: 'ambassadors',
        name: 'ambassadors',
        component: Ambassador,
        children: [
          {
            path: 'list',
            name: 'AmbassadorIndex',
            component: AmbassadorIndex
          },
          {
            path: 'read/:id',
            name: 'AmbassadorRead',
            component: AmbassadorRead
          },
          {
            path: 'update/:id',
            name: 'AmbassadorUpdate',
            component: AmbassadorUpdate
          }
          ,
          {
            path: 'add',
            name: 'AmbassadorCreate',
            component: AmbassadorCreate
          },
          {
            path: 'sales/:id/:discountCode',
            name: 'AmbassadorSales',
            component: SalesRead
          }
        ]
      },
      {
        path: 'orders',
        name: 'Orders',
        component: Order,
        children: [
          {
            path: 'list',
            name: 'OrderIndex',
            component: OrderIndex
          },
          {
            path: 'read/:id',
            name: 'OrderRead',
            component: OrderRead
          },
          {
            path: 'stats',
            name: 'OrderStats',
            component: OrderStats
          }
        ]
      },
      {
        path: 'users',
        name: 'Users',
        component: User,
        children: [
          {
            path: 'list',
            name: 'UserIndex',
            component: UserIndex
          },
          {
            path: 'read/:id',
            name: 'UserRead',
            component: UserRead
          }
        ]
      },
      {
        // L'abonnement premium (REDMINE-13522) : le catalogue des stores et le
        // journal de ce qu'ils envoient. Les abonnements d'un utilisateur sont
        // sur sa fiche.
        path: 'billing',
        name: 'Billing',
        component: Billing,
        children: [
          {
            path: 'products',
            name: 'BillingProducts',
            component: BillingProducts
          },
          {
            path: 'events',
            name: 'BillingEvents',
            component: BillingEvents
          },
          {
            path: 'grants',
            name: 'BillingGrants',
            component: BillingGrants
          }
        ]
      },
      {
        path: "algolia",
        name: 'Algolia',
        component: Algolia
      },
      {
        path: 'aerators',
        name: 'Aerators',
        component: Aerator,
        children: [
          {
            path: 'list',
            name: 'AeratorIndex',
            component: AeratorIndex
          },
          {
            path: 'create/package',
            name: "AeratorCreatePackage",
            component: AeratorCreatePackage
          },
          {
            path: 'create/firmware',
            name: "AeratorCreateFirmware",
            component: AeratorCreateFirmware
          },
          {
            path: 'create/bootloader',
            name: "AeratorCreateBootloader",
            component: AeratorCreateBootloader
          },
          {
            path: 'create/hardware',
            name: "AeratorCreateHardware",
            component: AeratorCreateHardware
          },
          {
            path: 'create/programmed/:userId/:aeratorId',
            name: "AeratorCreateProgrammed",
            component: AeratorCreateProgrammed
          },
          {
            path: 'update/package/:id',
            name: "AeratorUpdatePackage",
            component: AeratorUpdatePackage
          },
          {
            path: 'update/firmware/:id',
            name: "AeratorUpdateFirmware",
            component: AeratorUpdateFirmware
          },
          {
            path: 'update/bootloader/:id',
            name: "AeratorUpdateBootloader",
            component: AeratorUpdateBootloader
          },
          {
            path: 'update/hardware/:id',
            name: "AeratorUpdateHardware",
            component: AeratorUpdateHardware
          }
        ]
      },
      {
        path: 'wines',
        name: 'wines',
        component: Wine,
        children: [
          {
            path: 'list',
            name: 'WineIndex',
            component: WineIndex
          },
          {
            path: 'read/:id',
            name: 'WineRead',
            component: WineRead
          },
          {
            path: 'update/:id',
            name: 'WineUpdate',
            component: WineUpdate
          }
          ,
          {
            path: 'add',
            name: 'WineCreate',
            component: WineCreate
          }
        ]
      },
      {
        path: 'wine-templates',
        name: 'wine-templates',
        component: WineTemplate,
        children: [
          {
            path: 'list',
            name: 'WineTemplateIndex',
            component: WineTemplateIndex
          },
          {
            path: 'read/:id',
            name: 'WineTemplateRead',
            component: WineTemplateRead
          },
          {
            path: 'update/:id',
            name: 'WineTemplateUpdate',
            component: WineTemplateUpdate
          }
        ]
      },
      {
        path: 'wine-forms',
        name: 'wine-forms',
        component: WineForm,
        children: [
          {
            path: 'validate/:id',
            name: 'WineFormValidate',
            component: WineFormValidate
          },
          {
            path: 'list',
            name: 'WineFormIndex',
            component: WineFormIndex
          }
        ]
      },
/*
      {
        path: 'unchecked-wines',
        name: 'UncheckedWines',
        component: UncheckedWine,
        children: [
          {
            path: 'check/:id',
            name: 'UncheckedWinesCheck',
            component: UncheckedWineCheck
          },
          {
            path: 'list',
            name: 'UncheckedWinesIndex',
            component: UncheckedWineIndex
          }
        ]
      },
*/
      {
        path: 'wine-comments',
        name: 'wine-comments',
        component: Wine,
        children: [
          {
            path: 'validate',
            name: 'WineCommentValidate',
            component: WineCommentValidate
          }
        ]
      },
      {
        path: 'sales/:promotionCode',
        name: 'Sales',
        component: SalesRead
      },
      {
        path: 'aromas',
        name: 'aromas',
        component: Aroma,
        children: [
          {
            path: 'list',
            name: 'AromaIndex',
            component: AromaIndex
          },
          {
            path: 'create',
            name: 'AromaCreate',
            component: AromaCreate
          },
          {
            path: 'update/:id',
            name: 'AromaUpdate',
            component: AromaUpdate
          }
        ]
      },
      {
        path: 'food-pairings',
        name: 'food-pairings',
        component: FoodPairing,
        children: [
          {
            path: 'list',
            name: 'FoodPairingIndex',
            component: FoodPairingIndex
          },
          {
            path: 'create',
            name: 'FoodPairingCreate',
            component: FoodPairingCreate
          },
          {
            path: 'update/:id',
            name: 'FoodPairingUpdate',
            component: FoodPairingUpdate
          }
        ]
      },
      {
        path: 'ai-content-reports',
        name: 'ai-content-reports',
        component: AiContentReport,
        children: [
          {
            path: 'list',
            name: 'AiContentReportIndex',
            component: AiContentReportIndex
          }
        ]
      },
      {
        path: 'quizzes',
        name: 'quizzes',
        component: Quiz,
        children: [
          {
            path: 'list',
            name: 'QuizIndex',
            component: QuizIndex
          },
          {
            path: 'create',
            name: 'QuizCreate',
            component: QuizCreate
          },
          {
            path: 'update/:id',
            name: 'QuizUpdate',
            component: QuizUpdate
          }
        ]
      },
      {
        path: 'featured-regions/list',
        name: 'FeaturedRegionIndex',
        component: FeaturedRegionIndex
      },
      {
        path: 'featured-grapes/list',
        name: 'FeaturedGrapeIndex',
        component: FeaturedGrapeIndex
      },
      {
        path: 'wines-of-the-month',
        name: 'wines-of-the-month',
        component: WineOfTheMonth,
        children: [
          {
            path: 'list',
            name: 'WineOfTheMonthIndex',
            component: WineOfTheMonthIndex
          },
          {
            path: 'create',
            name: 'WineOfTheMonthCreate',
            component: WineOfTheMonthCreate
          },
          {
            path: 'update/:id',
            name: 'WineOfTheMonthUpdate',
            component: WineOfTheMonthUpdate
          }
        ]
      },
      {
        path: 'grapes',
        name: 'grapes',
        component: Grape,
        children: [
          {
            path: 'list',
            name: 'GrapeIndex',
            component: GrapeIndex
          },
          {
            path: 'read/:id',
            name: 'GrapeRead',
            component: GrapeRead
          },
          {
            path: 'create',
            name: 'GrapeCreate',
            component: GrapeCreate
          },
          {
            path: 'update/:id',
            name: 'GrapeUpdate',
            component: GrapeUpdate
          }
        ]
      },
      {
        path: 'sales/:promotionCode',
        name: 'Sales',
        component: SalesRead
      },
      {
        path: 'super-ambassadors',
        name: 'SuperAmbassadors',
        component: SuperAmbassador,
        children: [
          {
            path: 'list',
            name: 'SuperAmbassadorIndex',
            component: SuperAmbassadorIndex
          },
          {
            path: 'read/:id',
            name: 'SuperAmbassadorRead',
            component: SuperAmbassadorRead
          },
          {
            path: 'create',
            name: 'SuperAmbassadorCreate',
            component: SuperAmbassadorCreate
          },
          {
            path: 'update/:id',
            name: 'SuperAmbassadorUpdate',
            component: SuperAmbassadorUpdate
          },
          {
            path: 'sales/:id',
            name: 'SuperAmbassadorSales',
            component: SalesRead
          }
        ]
      },
      {
        path: 'announcements',
        name: 'announcements',
        component: Announcement,
        children: [
          {
            path: 'list',
            name: 'AnnouncementIndex',
            component: AnnouncementIndex
          },
          {
            path: 'create',
            name: 'AnnouncementCreate',
            component: AnnouncementCreate
          },
          {
            path: 'update/:id',
            name: 'AnnouncementUpdate',
            component: AnnouncementUpdate
          }
        ]
      },
      {
        path: 'appellations',
        name: 'appellations',
        component: Appellation,
        children: [
          {
            path: 'list',
            name: 'AppellationIndex',
            component: AppellationIndex
          },
          {
            path: 'read/:id',
            name: 'AppellationRead',
            component: AppellationRead
          },
          {
            path: 'create',
            name: 'AppellationCreate',
            component: AppellationCreate
          },
          {
            path: 'update/:id',
            name: 'AppellationUpdate',
            component: AppellationUpdate
          }
        ]
      },
      {
        path: 'domains',
        name: 'domains',
        component: Domain,
        children: [
          {
            path: 'list',
            name: 'DomainIndex',
            component: DomainIndex
          },
          {
            path: 'read/:id',
            name: 'DomainRead',
            component: DomainRead
          },
          {
            path: 'create',
            name: 'DomainCreate',
            component: DomainCreate
          },
          {
            path: 'update/:id',
            name: 'DomainUpdate',
            component: DomainUpdate
          }
        ]
      },
      {
        path: 'regions',
        name: 'regions',
        component: Region,
        children: [
          {
            path: 'list',
            name: 'RegionIndex',
            component: RegionIndex
          },
          {
            path: 'read/:id',
            name: 'RegionRead',
            component: RegionRead
          },
          {
            path: 'create',
            name: 'RegionCreate',
            component: RegionCreate
          },
          {
            path: 'update/:id',
            name: 'RegionUpdate',
            component: RegionUpdate
          }
        ]
      },
      {
        path: 'companies',
        name: 'companies',
        component: Company,
        children: [
          {
            path: 'list',
            name: 'CompanyIndex',
            component: CompanyIndex
          },
          {
            path: 'read/:id',
            name: 'CompanyRead',
            component: CompanyRead
          },
          {
            path: 'create',
            name: 'CompanyCreate',
            component: CompanyCreate
          },
          {
            path: 'update/:id',
            name: 'CompanyUpdate',
            component: CompanyUpdate
          }
        ]
      },

      {
        path: 'changelogs',
        name: 'changelogs',
        component: Changelog,
        children: [
          {
            path: 'list',
            name: 'ChangelogIndex',
            component: ChangelogIndex
          },
          {
            path: 'create',
            name: 'ChangelogCreate',
            component: ChangelogCreate
          },
          {
            path: 'update/:id',
            name: 'ChangelogUpdate',
            component: ChangelogUpdate
          }
        ]
      },
    ]
  },
  {
    path: '/login',
    alias: '/',
    name: 'Login',
    component: Login
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
